module.exports = __webpack_public_path__ + "img/man.0e72ea02.png";